import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import NRJiraSystemCheckIcon from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/NRJiraSystemCheckIcon';
import {
  JIRA_CONNECTION_HEALTH_LABELS,
  JIRA_SYSTEM_CHECK_STATUS
} from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/jiraIntegrationDetail.constants';
import { VULNERABILITY_JIRA_TICKETS_LABELS } from './vulnerabilityJiraTickets.constants';

function NRJiraDisconnectedTicketsAlert({ onReconnect, isReconnecting = false }) {
  const theme = useTheme();

  return (
    <Alert severity="error" icon={<NRJiraSystemCheckIcon status={JIRA_SYSTEM_CHECK_STATUS.ERROR} />} sx={{ alignItems: 'flex-start' }}>
      <AlertTitle sx={{ mb: theme.spacing(0.5) }}>{VULNERABILITY_JIRA_TICKETS_LABELS.DISCONNECTED_ALERT_TITLE}</AlertTitle>
      <Typography variant="body2" component="span">
        {`${VULNERABILITY_JIRA_TICKETS_LABELS.DISCONNECTED_ALERT_BODY} `}
        {onReconnect &&
          (isReconnecting ? (
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: theme.spacing(0.5), verticalAlign: 'baseline' }}>
              <CircularProgress size={14} color="inherit" aria-label={JIRA_CONNECTION_HEALTH_LABELS.RECONNECT} />
              <Typography component="span" variant="body2" color="text.secondary">
                {JIRA_CONNECTION_HEALTH_LABELS.RECONNECT}
              </Typography>
            </Box>
          ) : (
            <Link
              component="button"
              type="button"
              variant="body2"
              onClick={onReconnect}
              underline="always"
              sx={{
                verticalAlign: 'baseline',
                color: theme.palette.blue.link,
                cursor: 'pointer'
              }}
            >
              {JIRA_CONNECTION_HEALTH_LABELS.RECONNECT}
            </Link>
          ))}
      </Typography>
    </Alert>
  );
}

export default NRJiraDisconnectedTicketsAlert;
